<script setup lang="ts">
import { useAttrs } from "vue";

const attrs = useAttrs();

const props = defineProps<{ sizes?: string; img: unknown }>();

const assets = computed(() => {
  return props.img?.asset || props.img?.fields?.asset; // Make masterData and contentfulData work
});
const altText = computed(() => {
  return props.img?.fields?.altText || props.img?.altText || "";
});

const modifiers = (asset) => {
  // focuspoint
  const mod = {};

  const extractFocuspoint = (url) => {
    var rx = /focuspoint\=([^&#]+)/g;
    var arr = rx.exec(url);
    return arr ? arr[1] : null;
  };

  // dimensions from attrs
  if (attrs.width) {
    mod.width = attrs.width;
  }
  if (attrs.height) {
    mod.height = attrs.height;
  }

  const fp = extractFocuspoint(asset.selectedFile.url + "&");
  if (fp) {
    mod.focuspoint = fp;
  }

  return mod;
};

const focusStyle = (asset) => {
  const imgUrl = new URL(asset.selectedFile?.url);
  const params = new URLSearchParams(imgUrl.search);
  if (params.get("focuspoint")) {
    const fp = params.get("focuspoint").split(",");
    return `object-position: ${fp[0] * 100}% ${fp[1] * 100}%`;
  }

  return undefined;
};
</script>

<template>
  <DevMessage v-if="!assets">Image not available</DevMessage>

  <NuxtImg
    v-else
    v-for="asset in assets"
    provider="bynder"
    loading="lazy"
    :src="asset.selectedFile.url"
    :alt="altText"
    format="webp"
    densities="x1"
    :sizes="sizes ? sizes : 'xs:100vw sm:768px md:1280px xl:1600px xxl:1920px'"
    :style="focusStyle(asset)"
    v-bind="$attrs"
    :modifiers="modifiers(asset)"
  />
</template>

<style lang="scss" scoped>
img {
  &.hidden {
    display: none;
  }

  &.show {
    display: inline-block;
  }

  @include sm {
    &.hidden-sm {
      display: none;
    }

    &.show-sm {
      display: inline-block;
    }
  }

  @include md {
    &.hidden-md {
      display: none;
    }

    &.show-md {
      display: inline-block;
    }
  }

  @include lg {
    &.hidden-lg {
      display: none;
    }

    &.show-lg {
      display: inline-block;
    }
  }

  @include xl {
    &.hidden-xl {
      display: none;
    }

    &.show-xl {
      display: inline-block;
    }
  }
}
</style>
